import { Factory } from 'rosie';
import '../conversation_item_factory';

Factory.define('VoiceAICall').attr('type', 'VOICE_AI_CALL');

Factory.define('VoiceAICallDefaults')
    .extend('VoiceAICall')
    .attr('automationSessionId', 'automation-session-id')
    .attr('isTranscriptCollapsed', false);

Factory.define('VoiceAICallItem')
    .extend('ConversationItem')
    .attr('content', ['content'], content => Factory.attributes('VoiceAICall', content));

Factory.define('VoiceAICallItemWithDefaults')
    .extend('ConversationItemWithDefaults')
    .attr('content', ['content'], content => Factory.attributes('VoiceAICallDefaults', content));